import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Table,
  InputGroup,
  Card,
  Button,
  Form
} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';

// types
import { RESPONSE_CODE } from 'types/const';
// function
import { getLoginInform } from 'function/login';
import { downloadExcelByTable } from 'function/file';
// api
import { factory } from 'api/haccp/commonApi';
import { mjRwmtrReport } from 'api/haccp/report/rawMaterialStatusApi';

/*
 * 보고서 > 주요원료도입현황
 */
const List = () => {
  /* variable */
  const monthTableTitle = '최근 3개월 주요 원료 도입 현황';
  const yearTableTitle = '연간 모선 도입 횟수';

  /* state */
  // 관리자여부
  const [adminYn, setAdminYn] = useState(null); // Y: 관리자, N: 이천,군산 담당자
  // 공장 Select Box
  const [factoryOptions, setFactoryOptions] = useState(null);

  // 조회조건
  //공장
  const [pltCd, setPltCd] = useState(''); // 공장
  // 조회월
  const [month, setMonth] = useState(new Date());

  // 조회월 최근3개월
  const [lastThreeMonth, setLastThreeMonth] = useState({
    beforeMonth: moment(new Date()).subtract('2', 'M').format('YYYY-MM'),
    nowMonth: moment(new Date()).format('YYYY-MM')
  });
  // 조회연도
  const [year, setYear] = useState(moment(new Date()).format('YYYY'));
  // 최근3개월 주요원료 도입현황
  const [monthData, setMonthData] = useState([]);
  const [monthDataMaxRow, setMonthDataMaxRow] = useState(0);
  const [monthCcpCountData, setMonthCcpCountData] = useState({});

  // 연간 모선 도입횟수
  const [yearData, setYearData] = useState([]);
  const [yearDataMaxRow, setYearDataMaxRow] = useState(0);
  const [yearCcpCountData, setYearCcpCountData] = useState({});

  /* event */

  /* 엑셀다운로드 */
  const onExcelDown = (tableId, title) => {
    const excelTilte = `${title}.xlsx`;
    const reportTable = document.getElementById(tableId);
    downloadExcelByTable(reportTable, excelTilte);
  };

  /* 조회 */
  const onSearch = async () => {
    const params = {
      pltCd: pltCd,
      year: Number(moment(month).format('YYYY')),
      month: Number(moment(month).format('MM'))
    };

    Object.keys(params).forEach(
      key => (params[key] === '' || params[key] === 'ALL') && delete params[key]
    );

    const response = await mjRwmtrReport(params);

    const { code, data } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    const { last3MthsStt, yearStt } = data || {};

    // 최근 3개월 주요 원료 도입 현황
    const {
      array: monthArray,
      maxRow: monthMaxRow,
      ccpCountData: monthCcpCountData
    } = tableDataConvert(last3MthsStt);
    setMonthData(monthArray);
    setMonthDataMaxRow(monthMaxRow);
    setMonthCcpCountData(monthCcpCountData);

    // 연간 모선 도입 횟수
    const {
      array: yearArray,
      maxRow: yearMaxRow,
      ccpCountData: yearCcpCountData
    } = tableDataConvert(yearStt);
    setYearData(yearArray);
    setYearDataMaxRow(yearMaxRow);
    setYearCcpCountData(yearCcpCountData);

    // 조회월 최근3개월
    setLastThreeMonth({
      ...lastThreeMonth,
      beforeMonth: moment(month).subtract('2', 'M').format('YYYY-MM'),
      nowMonth: moment(month).format('YYYY-MM')
    });

    // 조회연도
    const year = moment(month).format('YYYY');
    setYear(year);
  };

  /**
   * last3MthsStt: 최근 3개월 주요 원료 도입 현황,
   * yearStt: 연간 모선 도입 횟수
   * Table Data 가공
   */
  const tableDataConvert = data => {
    const {
      maxRow, // 원산지 data max row
      rw1R101, // 옥수수
      rw1R103, // 소맥
      rw1R207, // 단백피
      rw1R401, // 대두박
      rw1R402, // 채종박
      rw1R411, // 팜박
      rw1R412, // 야자박
      rw1R415 // 루핀시드
    } = data || {};

    // 원산지 Table Data 가공
    let array = [];
    for (let i = 0; i < maxRow; i++) {
      let obj = {
        coriNm1: rw1R101?.list[i]?.coriNm ?? null, // 옥수수 원산지
        coriCnt1: rw1R101?.list[i]?.cnt ?? 0, // 옥수수 빈도
        coriNm2: rw1R103?.list[i]?.coriNm ?? null, // 소맥 원산지
        coriCnt2: rw1R103?.list[i]?.cnt ?? 0, // 소맥 빈도
        coriNm3: rw1R207?.list[i]?.coriNm ?? null, // 단백피 원산지
        coriCnt3: rw1R207?.list[i]?.cnt ?? 0, // 단백피박 빈도
        coriNm4: rw1R401?.list[i]?.coriNm ?? null, // 대두박 원산지
        coriCnt4: rw1R401?.list[i]?.cnt ?? 0, // 대두박 빈도
        coriNm5: rw1R402?.list[i]?.coriNm ?? null, // 채종박 원산지
        coriCnt5: rw1R402?.list[i]?.cnt ?? 0, // 채종박 빈도
        coriNm6: rw1R411?.list[i]?.coriNm ?? null, // 팜박 원산지
        coriCnt6: rw1R411?.list[i]?.cnt ?? 0, // 팜박 빈도
        coriNm7: rw1R412?.list[i]?.coriNm ?? null, // 야자박 원산지
        coriCnt7: rw1R412?.list[i]?.cnt ?? 0, // 야자박 빈도
        coriNm8: rw1R415?.list[i]?.coriNm ?? null, // 루핀시드 원산지
        coriCnt8: rw1R415?.list[i]?.cnt ?? 0 // 루핀시드 빈도
      };

      array = [...array, obj];
    }

    // ccp여부, 총빈도 Table Data 가공
    let ccpCountData = {};
    Object.entries(data).map(([key, value]) => {
      if (key !== 'maxRow') {
        let obj = {
          [`${key}CcpYn`]: value.ccpYn,
          [`${key}Sum`]: value.sum
        };

        ccpCountData = { ...ccpCountData, ...obj };
      }
    });

    return { array, maxRow, ccpCountData };
  };

  // 공장목록 API
  const factoryList = async () => {
    const response = await factory();

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    setFactoryOptions(list);
  };

  // 로그인 정보
  const loginInfo = () => {
    const { adminYn, pltCd } = getLoginInform();

    if (adminYn === 'Y') {
      setAdminYn(adminYn);
      return;
    }

    setPltCd(pltCd);
    setAdminYn(adminYn);
  };

  /* watch */
  useEffect(() => {
    // 공장 API 호출
    factoryList();
    // 로그인정보
    loginInfo();
  }, []);

  useEffect(() => {
    if (adminYn === null) return;
    onSearch();
  }, [adminYn]);

  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center g-2">
            <Col>
              <h5 className="mb-0">주요 원료 도입 현황</h5>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="pt-0">
          <Row className="ms-0 me-0 mt-3">
            {/* 조회월 선택 */}
            <Col sm={3} className="ps-0">
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Text>조회월</InputGroup.Text>
                <div className="flex-fill">
                  <DatePicker
                    onKeyDown={e => {
                      e.preventDefault();
                    }}
                    locale="ko"
                    dateFormat="yyyy년 MM월"
                    className="form-control form-control-sm"
                    showMonthYearPicker
                    onChange={e => setMonth(moment(e).format('YYYY-MM'))}
                    selected={new Date(month)}
                  />
                </div>
              </InputGroup>
            </Col>
            {/* 공장 선택 select-box */}
            <Col sm={2} className="ps-1 pe-1">
              <Form.Select
                size="sm"
                onChange={({ target: { value } }) => setPltCd(value)}
                value={pltCd}
                disabled={adminYn === 'N'}
              >
                <option disabled value="">
                  공장선택
                </option>
                <option value="ALL">전체</option>
                {factoryOptions?.map(option => (
                  <option key={option.pltCd} value={option.pltCd}>
                    {option.pltNmKo}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col>
              <Button size="sm" onClick={onSearch}>
                조회
              </Button>
            </Col>
          </Row>
          <Row className="align-items-center g-2 mb-2">
            <Col className="d-flex align-items-center">
              <h6 className="fs-0 mb-0">{monthTableTitle}</h6>
              <p className="mb-0 ms-4 fs--1 fw-bold lh-1">
                {lastThreeMonth.beforeMonth} ~ {lastThreeMonth.nowMonth}
              </p>
            </Col>
            <Col xs={'auto'}>
              <Button
                xs={'auto'}
                size="sm"
                variant="secondary"
                onClick={() =>
                  onExcelDown(
                    'monthTable',
                    `${monthTableTitle}(${lastThreeMonth.beforeMonth}~${lastThreeMonth.nowMonth})`
                  )
                }
                disabled={monthData?.length === 0}
              >
                엑셀 다운로드
              </Button>
            </Col>
          </Row>

          {/* 최근 3개월 주요 원료 도입 현황 */}
          <Table
            responsive
            bordered
            className="fs--1 text-center mb-3"
            id="monthTable"
          >
            <thead className="bg-200 text-700 align-middle border-300">
              <tr>
                <th className="text-nowrap">원료명</th>
                <th className="text-nowrap" colSpan={2}>
                  옥수수
                </th>
                <th className="text-nowrap" colSpan={2}>
                  소맥
                </th>
                <th className="text-nowrap" colSpan={2}>
                  단백피
                </th>
                <th className="text-nowrap" colSpan={2}>
                  대두박
                </th>
                <th className="text-nowrap" colSpan={2}>
                  채종박
                </th>
                <th className="text-nowrap" colSpan={2}>
                  팜박
                </th>
                <th className="text-nowrap" colSpan={2}>
                  야자박
                </th>
                <th className="text-nowrap" colSpan={2}>
                  루핀시드
                </th>
              </tr>
            </thead>
            <tbody className="align-middle">
              {monthData.length > 0 && (
                <>
                  <tr>
                    <td className="bg-200 border-bottom border-300">
                      CCP 여부
                    </td>
                    <td colSpan={2}>
                      {monthCcpCountData?.rw1R101CcpYn || '-'}
                    </td>
                    <td colSpan={2}>
                      {monthCcpCountData?.rw1R103CcpYn || '-'}
                    </td>
                    <td colSpan={2}>
                      {monthCcpCountData?.rw1R207CcpYn || '-'}
                    </td>
                    <td colSpan={2}>
                      {monthCcpCountData?.rw1R401CcpYn || '-'}
                    </td>
                    <td colSpan={2}>
                      {monthCcpCountData?.rw1R402CcpYn || '-'}
                    </td>
                    <td colSpan={2}>
                      {monthCcpCountData?.rw1R411CcpYn || '-'}
                    </td>
                    <td colSpan={2}>
                      {monthCcpCountData?.rw1R412CcpYn || '-'}
                    </td>
                    <td colSpan={2}>
                      {monthCcpCountData?.rw1R415CcpYn || '-'}
                    </td>
                  </tr>

                  <tr>
                    <td className="bg-200 border-bottom border-300">총빈도</td>
                    <td colSpan={2}>{monthCcpCountData?.rw1R101Sum || '-'}</td>
                    <td colSpan={2}>{monthCcpCountData?.rw1R103Sum || '-'}</td>
                    <td colSpan={2}>{monthCcpCountData?.rw1R207Sum || '-'}</td>
                    <td colSpan={2}>{monthCcpCountData?.rw1R401Sum || '-'}</td>
                    <td colSpan={2}>{monthCcpCountData?.rw1R402Sum || '-'}</td>
                    <td colSpan={2}>{monthCcpCountData?.rw1R411Sum || '-'}</td>
                    <td colSpan={2}>{monthCcpCountData?.rw1R412Sum || '-'}</td>
                    <td colSpan={2}>{monthCcpCountData?.rw1R415Sum || '-'}</td>
                  </tr>
                  <tr className="bg-200 border-300">
                    <td className="border-y" rowSpan={monthDataMaxRow + 1}>
                      원산지
                    </td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                  </tr>

                  {monthData?.map(
                    (
                      {
                        coriNm1,
                        coriCnt1,
                        coriNm2,
                        coriCnt2,
                        coriNm3,
                        coriCnt3,
                        coriNm4,
                        coriCnt4,
                        coriNm5,
                        coriCnt5,
                        coriNm6,
                        coriCnt6,
                        coriNm7,
                        coriCnt7,
                        coriNm8,
                        coriCnt8
                      },
                      index
                    ) => (
                      <tr key={index}>
                        <td>{coriNm1 || '-'}</td>
                        <td>{coriCnt1 || '-'}</td>
                        <td>{coriNm2 || '-'}</td>
                        <td>{coriCnt2 || '-'}</td>
                        <td>{coriNm3 || '-'}</td>
                        <td>{coriCnt3 || '-'}</td>
                        <td>{coriNm4 || '-'}</td>
                        <td>{coriCnt4 || '-'}</td>
                        <td>{coriNm5 || '-'}</td>
                        <td>{coriCnt5 || '-'}</td>
                        <td>{coriNm6 || '-'}</td>
                        <td>{coriCnt6 || '-'}</td>
                        <td>{coriNm7 || '-'}</td>
                        <td>{coriCnt7 || '-'}</td>
                        <td>{coriNm8 || '-'}</td>
                        <td>{coriCnt8 || '-'}</td>
                      </tr>
                    )
                  )}
                </>
              )}
              {monthData?.length < 1 && (
                <tr>
                  <td colSpan={17} className="w-auto">
                    최근3개월 주요 원료 도입현황 데이터가 존재하지 않습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <Row className="align-items-center g-2 mb-2">
            <Col className="d-flex align-items-center">
              <h6 className="fs-0 mb-0">{yearTableTitle}</h6>
              <p className="mb-0 ms-4 fs--1 fw-bold lh-1">{year}년</p>
            </Col>
            <Col xs={'auto'}>
              <Button
                size="sm"
                variant="secondary"
                onClick={() =>
                  onExcelDown('yearTable', `${yearTableTitle}(${year}년)`)
                }
                disabled={yearData?.length === 0}
              >
                엑셀 다운로드
              </Button>
            </Col>
          </Row>
          <Table
            responsive
            bordered
            className="fs--1 text-center mb-0"
            id="yearTable"
          >
            <thead className="bg-200 text-700 align-middle border-300">
              <tr>
                <th className="text-nowrap">원료명</th>
                <th className="text-nowrap" colSpan={2}>
                  옥수수
                </th>
                <th className="text-nowrap" colSpan={2}>
                  소맥
                </th>
                <th className="text-nowrap" colSpan={2}>
                  단백피
                </th>
                <th className="text-nowrap" colSpan={2}>
                  대두박
                </th>
                <th className="text-nowrap" colSpan={2}>
                  채종박
                </th>
                <th className="text-nowrap" colSpan={2}>
                  팜박
                </th>
                <th className="text-nowrap" colSpan={2}>
                  야자박
                </th>
                <th className="text-nowrap" colSpan={2}>
                  루핀시드
                </th>
              </tr>
            </thead>
            <tbody className="align-middle">
              {yearData.length > 0 && (
                <>
                  <tr>
                    <td className="bg-200 border-bottom border-300">
                      CCP 여부
                    </td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R101CcpYn || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R103CcpYn || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R207CcpYn || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R401CcpYn || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R402CcpYn || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R411CcpYn || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R412CcpYn || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R415CcpYn || '-'}</td>
                  </tr>

                  <tr>
                    <td className="bg-200 border-bottom border-300">총빈도</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R101Sum || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R103Sum || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R207Sum || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R401Sum || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R402Sum || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R411Sum || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R412Sum || '-'}</td>
                    <td colSpan={2}>{yearCcpCountData?.rw1R415Sum || '-'}</td>
                  </tr>
                  <tr className="bg-200 border-300">
                    <td className="border-y" rowSpan={yearDataMaxRow + 1}>
                      원산지
                    </td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                    <td className="border-y">원산지</td>
                    <td className="border-y">빈도</td>
                  </tr>
                  {yearData?.map(
                    (
                      {
                        coriNm1,
                        coriCnt1,
                        coriNm2,
                        coriCnt2,
                        coriNm3,
                        coriCnt3,
                        coriNm4,
                        coriCnt4,
                        coriNm5,
                        coriCnt5,
                        coriNm6,
                        coriCnt6,
                        coriNm7,
                        coriCnt7,
                        coriNm8,
                        coriCnt8
                      },
                      index
                    ) => (
                      <tr key={index}>
                        <td>{coriNm1 || '-'}</td>
                        <td>{coriCnt1 || '-'}</td>
                        <td>{coriNm2 || '-'}</td>
                        <td>{coriCnt2 || '-'}</td>
                        <td>{coriNm3 || '-'}</td>
                        <td>{coriCnt3 || '-'}</td>
                        <td>{coriNm4 || '-'}</td>
                        <td>{coriCnt4 || '-'}</td>
                        <td>{coriNm5 || '-'}</td>
                        <td>{coriCnt5 || '-'}</td>
                        <td>{coriNm6 || '-'}</td>
                        <td>{coriCnt6 || '-'}</td>
                        <td>{coriNm7 || '-'}</td>
                        <td>{coriCnt7 || '-'}</td>
                        <td>{coriNm8 || '-'}</td>
                        <td>{coriCnt8 || '-'}</td>
                      </tr>
                    )
                  )}
                </>
              )}
              {yearData?.length < 1 && (
                <tr>
                  <td colSpan={17} className="w-auto">
                    연간모선 도입횟수 데이터가 존재하지 않습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
};

export default List;
